// @ts-nocheck
/* eslint-disable spire/export-styles */
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import setDeliveryScheduleModalIsOpen from "@insite/client-framework/Store/Components/ProductDeliverySchedule/Handlers/SetDeliveryScheduleModalIsOpen";
import translate from "@insite/client-framework/Translate";
import { ProductSubscriptionDto } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import React, { useState } from "react";
import { useDispatch } from "react-redux";

/* Starter Custom Code - Start */
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import CarFill from "@store/Library/Components/Toolkit/Icons/Car/CarFill";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
/* Starter Custom Code - End */

interface OwnProps {
    subscription: ProductSubscriptionDto;
    labelOverride?: string;
    disabled?: boolean;
    onSave?: (subscription: ProductSubscriptionDto) => void;
    extendedStyles?: LinkPresentationProps; // Starter Custom Code
    // Starter Custom Code
    overridedStyles?: LinkPresentationProps;
}

// Starter Custom Code - next line - changed typed
export const productDeliveryScheduleButtonStyles: LinkPresentationProps = {
    ...linkGetActionLinkProps(CarFill),
};

const ProductDeliveryScheduleButton = ({
    subscription,
    labelOverride,
    disabled,
    onSave,
    extendedStyles,
    overridedStyles, // Starter Custom Code
    ...otherProps
}: OwnProps) => {
    const dispatch = useDispatch();

    const styles = useExpandProps(productDeliveryScheduleButtonStyles, extendedStyles, overridedStyles); // Starter Custom Code

    const deliveryScheduleClickHandler = () => {
        dispatch(setDeliveryScheduleModalIsOpen({ isOpen: true, subscription, onSave }));
    };

    return (
        <Link // Starter Custom Code
            {...styles}
            onClick={deliveryScheduleClickHandler}
            disabled={disabled}
            data-test-selector="deliverySchedule"
            {...otherProps}
        >
            {labelOverride ?? translate("Delivery Schedule")}
        </Link>
    );
};
export default ProductDeliveryScheduleButton;
